import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { MdArrowDropDown } from "react-icons/md";
import { motion } from "framer-motion";
import "./navbar.css";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  const menuRef = useRef(null);
  const dropdownRef = useRef(null);
  const menuToggleRef = useRef(null);

  // Data produk untuk dropdown
  const products = [
    { path: "/product-1", label: "HRIS" },
    { path: "/product-2", label: "ERP System Customized" },
    { path: "/product-3", label: "Path Finding Machine" },
  ];

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle click outside menu and dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !menuToggleRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Determine active tab based on current path
  const activeTab = (() => {
    const path = location.pathname;
    if (path === "/home") return "home";
    if (path === "/company-profile    ") return "company-profile";
    if (path === "/our-products" || products.map((p) => p.path).includes(path))
      return "our-products";
    if (path === "/contact-us") return "contact-us";
    if (path === "/blog") return "blog";
    return "";
  })();

  // Toggle menu open/close
  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
    setDropdownOpen(false); // Close dropdown when menu is toggled
  };

  return (
    <motion.nav
      className={`navbar ${isScrolled ? "solid" : "transparent"}`}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Logo and Company Name */}
      <div className="logo-container" onClick={() => (window.location.href = "/home")}>
        <motion.img
          src="marsl.png"
          alt="Logo PT Mars Acme Perkasa"
          className="logo"
          whileHover={{ scale: 1.1 }}
        />
        <div className="text-container">
          <h1 className="company-name">PT Mars Acme Perkasa</h1>
          <p>We Make it Goes On</p>
        </div>
      </div>

      {/* Menu Toggle Button (Mobile) */}
      <button className="menu-toggle" onClick={handleMenuToggle} ref={menuToggleRef}>
        &#9776;
      </button>

      {/* Menu Items */}
      <ul className={`menu ${menuOpen ? "open" : ""}`} ref={menuRef}>
        {/* Home and About Us */}
        {[
          { path: "/home", label: "Home" },
          { path: "/company-profile", label: "About Us" },
        ].map(({ path, label }) => (
          <motion.li
            key={path}
            className={activeTab === path.slice(1) ? "active" : ""}
            whileHover={{ scale: 1.1 }}
          >
            <Link to={path}>{label}</Link>
          </motion.li>
        ))}

        {/* Our Products with Dropdown */}
        <li
          className={`dropdown ${activeTab === "our-products" ? "active" : ""}`}
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
          ref={dropdownRef}
        >
          <Link to="/our-products" className="dropdown-link">
             Our Products{/* <MdArrowDropDown /> */}
          </Link>
          {/* {dropdownOpen && (
            <motion.ul
              className="dropdown-menu"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
            >
              {products.map(({ path, label }) => (
                <motion.li key={path} whileHover={{ scale: 1.05 }}>
                  <Link to={path}>{label}</Link>
                </motion.li>
              ))}
            </motion.ul>
          )} */}
        </li>

        {/* Contact Us (Blog is hidden) */}
        {[
          { path: "/contact-us", label: "Contact Us" },
          { path: "/blog", label: "Blog", hidden: true },
        ]
          .filter(({ hidden }) => !hidden)
          .map(({ path, label }) => (
            <motion.li
              key={path}
              className={activeTab === path.slice(1) ? "active" : ""}
              whileHover={{ scale: 1.1 }}
            >
              <Link to={path}>{label}</Link>
            </motion.li>
          ))}
      </ul>
    </motion.nav>
  );
}

export default Navbar;